import { applicationCreateRoute } from "modules/applications/routes";
import { userManagementRoutes } from "modules/user-management/routes";

export const NON_ENV_BASED_ROUTES = [
  userManagementRoutes.path,
  applicationCreateRoute.path,
] as const;
